import { useEffect, useState } from "react";
import { Modal, Button, Table } from "react-bootstrap";
import toast from "react-hot-toast";
import { desvincularCosto, getVinculosDeCosto } from "../../utils/costosProyecto";
import { useCurrency } from "../../utils/useCurrency";

// Sub-modal "Desvincular" (menú ⋮ de CarteleriaCostosModal, Fase 4 — 2026-10-04; Fase 5 — 2026-10-04
// agrega los anticipos a la misma lista). Lista los vínculos VIGENTES de una línea de costo (factura
// o anticipo, con su folio/fecha) y permite desvincular uno por uno. Desvincular es reversa por
// evento (10.248): `desvincular_costo` nunca borra la fila, fija `reversado_at`. No toca
// pagos/saldos/libro del proveedor.
const VinculosCostoModal = ({ show, costo, userId, onHide, onCambio }) => {
  const [cargando, setCargando] = useState(true);
  const [vinculos, setVinculos] = useState([]);
  const [desvinculando, setDesvinculando] = useState(null); // id en curso

  const { formatAmount } = useCurrency();

  const cargar = async () => {
    setCargando(true);
    try {
      setVinculos(await getVinculosDeCosto(costo.id));
    } catch (e) {
      toast.error(`Error al cargar vínculos: ${e.message || e}`);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [costo.id]);

  const handleDesvincular = async (vinculoId) => {
    if (!window.confirm("¿Desvincular esta factura de la línea de costo?")) return;
    setDesvinculando(vinculoId);
    try {
      const resultado = await desvincularCosto({
        vinculoId,
        usuarioId: Number.isFinite(Number(userId)) ? Number(userId) : null,
      });
      toast.success("Factura desvinculada");
      await cargar();
      onCambio?.(resultado);
    } catch (err) {
      toast.error("Error al desvincular: " + (err.message || err));
    } finally {
      setDesvinculando(null);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Facturas vinculadas — {costo?.concepto}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {cargando ? (
          <div style={{ textAlign: "center", padding: 20 }}>Cargando…</div>
        ) : vinculos.length === 0 ? (
          <div style={{ color: "#999", textAlign: "center", padding: 20 }}>
            Esta línea no tiene ninguna factura vinculada.
          </div>
        ) : (
          <Table size="sm" bordered>
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Documento / pago</th>
                <th>Fecha</th>
                <th style={{ textAlign: "right" }}>Monto (neto)</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {vinculos.map((v) => (
                <tr key={v.id}>
                  <td>
                    {v.tipo === "anticipo" ? (
                      <span
                        style={{
                          fontSize: "0.7rem",
                          padding: "2px 6px",
                          borderRadius: 3,
                          background: "#e2e3e5",
                          color: "#383d41",
                        }}
                      >
                        Anticipo
                      </span>
                    ) : (
                      <span
                        style={{
                          fontSize: "0.7rem",
                          padding: "2px 6px",
                          borderRadius: 3,
                          background: "#d1ecf1",
                          color: "#0c5460",
                        }}
                      >
                        Factura
                      </span>
                    )}
                  </td>
                  <td>{v.folioLabel}</td>
                  <td>{v.fechaEmision || "—"}</td>
                  <td style={{ textAlign: "right" }}>{formatAmount(v.montoNeto, costo.moneda)}</td>
                  <td>
                    <Button
                      size="sm"
                      variant="outline-danger"
                      disabled={desvinculando === v.id}
                      onClick={() => handleDesvincular(v.id)}
                    >
                      {desvinculando === v.id ? "…" : "Desvincular"}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default VinculosCostoModal;
